import { Translation } from '@ps/web-shared-components';
import { minLength, noWhiteStartOrEnd, numbersOnly } from '@ps/web-shared-validators';
import React from 'react';

import { stripNonDigits } from '../../../../../../utils/cashier';
import TextInput from '../../../../../TextInput/TextInput';
import RMFSSNContainer from '../RMFSSNContainer/RMFSSNContainer';

import {
  TXTCLI_WhatXs_your_SSNX,
  TXTCLI_Your_SSN,
  TXTMOB_Please_enter_the_last_4_digits_ELL,
  TXTWCL_SSN,
  TXTWCL_We_keep_your_data_safe
} from './RMFSSN5.messages.json';

const RMFSSN5: React.FC<{ page: React.ComponentType }> = ({ page }) => (
  <RMFSSNContainer
    showLockIcon
    title={TXTCLI_Your_SSN}
    pageTopTitle={TXTCLI_WhatXs_your_SSNX}
    pageTopSubtitle={<Translation {...TXTWCL_We_keep_your_data_safe} />}
    page={page}
  >
    <TextInput
      id="nationalDocumentNumber"
      type="tel"
      label={TXTWCL_SSN}
      validators={[
        noWhiteStartOrEnd,
        numbersOnly(TXTMOB_Please_enter_the_last_4_digits_ELL),
        minLength(4, TXTMOB_Please_enter_the_last_4_digits_ELL)
      ]}
      maxLength={4}
      numericKeyboard
      parse={stripNonDigits}
      placeholder="0000"
      helperMessage={<Translation {...TXTMOB_Please_enter_the_last_4_digits_ELL} />}
    />
  </RMFSSNContainer>
);

export default RMFSSN5;
